import React from 'react'

export default function HoursMetricsBar({ metrics = {}, loading = false }) {
  const cards = [
    {
      label: 'Delivered Lectures',
      value: loading ? '—' : `${metrics.totalRecords || 0} Sessions`,
      icon: 'timelapse',
      color: 'text-primary',
      bg: 'bg-primary/10',
      border: 'border-primary/20',
    },
    {
      label: 'Total Teaching Time',
      value: loading ? '—' : metrics.totalHoursString || '0:00 hrs',
      icon: 'schedule',
      color: 'text-emerald-600',
      bg: 'bg-emerald-500/10',
      border: 'border-emerald-500/20',
    },
    {
      label: 'Active Faculty',
      value: loading ? '—' : `${metrics.uniqueFacultyCount || 0} Instructors`,
      icon: 'school',
      color: 'text-indigo-600',
      bg: 'bg-indigo-500/10',
      border: 'border-indigo-500/20',
    },
    {
      label: 'Avg Session Length',
      value: loading ? '—' : `${metrics.avgDurationMinutes || 0} mins`,
      icon: 'avg_time',
      color: 'text-amber-600',
      bg: 'bg-amber-500/10',
      border: 'border-amber-500/20',
    },
  ]

  return (
    <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
      {cards.map((card) => (
        <div
          key={card.label}
          className="flex items-center gap-3.5 rounded-2xl border border-outline-variant/25 bg-surface-container-lowest p-4 shadow-xs"
        >
          <div className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${card.bg} ${card.color}`}>
            <span className="material-symbols-outlined text-xl">{card.icon}</span>
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-[11px] font-black uppercase tracking-wider text-on-surface-variant truncate">
              {card.label}
            </p>
            <p className="mt-0.5 font-display text-lg font-black tracking-tight text-on-surface truncate">
              {card.value}
            </p>
          </div>
        </div>
      ))}
    </div>
  )
}
